module.exports = __webpack_public_path__ + "media/application/images/svgs/logo-6193d4608f9dc5c9c4642c9fc16ac8c4.svg";